import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { AuthService } from '../../Service/AuthService';
import { setAuthUser, setToken } from '../../store/user/user-slice';
import { createNotification } from '../../store/notifications/notification-slice';
import { LocalStorageService } from '../../Service/LocalStorageService';
import { StrategyService } from '../../Service/StrategyService';

type Props = {
  setIsLoading: (value: boolean) => void;
};
const Loader = ({ setIsLoading }: Props) => {
  const accessToken = LocalStorageService.getItem('accessToken');
  const getAccessToken = useAppSelector(state => state.user.user?.accessToken);

  const getRole = LocalStorageService.getItem('role');
  const appDispatch = useAppDispatch();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setIsLoading(true);

        if (getRole === 'admin') {
          const userResponse = await AuthService.getMe();
          LocalStorageService.setItem('role', userResponse.data.role);
          appDispatch(setToken(accessToken));
          appDispatch(setAuthUser(userResponse.data));
        } else {
          const [userResponse] = await Promise.all([
            AuthService.getMe(),
            // StrategyService.getStrategies(),
          ]);
          appDispatch(setToken(accessToken));
          appDispatch(setAuthUser(userResponse.data));
        }
      } catch (error) {
        appDispatch(
          createNotification({
            type: 'error',
            message: 'Something went wrong! Please try again later.',
          })
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (accessToken || getAccessToken) fetchUser();

    return () => {
      setIsLoading(false);
    };
  }, [accessToken, getAccessToken]);

  return <></>;
};

export default Loader;
